import { Avatar, Button } from "@fluentui/react-components";
import {
  TableCell,
  TableCellLayout,
  TableRow,
  TableSelectionCell,
  TableRowData as RowStateBase,
} from "@fluentui/react-components/unstable";
import { ListChildComponentProps } from "react-window";
import { IUser } from "../../services/types/table";
import { AppConfirmdialog, UserContractTypeDialog } from "../common";
import { useState } from "react";
import { usersService } from "../../services";
import { getContractTypeLabel, parseContractType } from "../../utils/contractType";

interface ReactWindowRenderFnProps extends ListChildComponentProps {
  data: TableRowData[];
}
interface TableRowData extends RowStateBase<IUser> {
  getUsers: () => void;
  onClick: (e: React.MouseEvent) => void;
  selected: boolean;
  appearance: "brand" | "none";
  assigned: boolean;
}

const UserListRow = ({ index, style, data }: ReactWindowRenderFnProps) => {
  const { item, selected, appearance, getUsers, onClick, assigned } = data[index];
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openContractDialog, setOpenContractDialog] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isUpdatingContract, setIsUpdatingContract] = useState(false);
  const [contractType, setContractType] = useState<number | null>(() =>
    parseContractType(item.contractType)
  );

  const deleteUser = () => {
    setIsDeleting(true);
    usersService.deleteUser(item.id)
      .then(() => {
        setIsDeleting(false);
        setOpenDeleteDialog(false);
        getUsers();
      });
  };

  const updateContractType = () => {
    if (contractType === null) {
      return;
    }

    setIsUpdatingContract(true);
    usersService.updateUserContractType(item.id, contractType)
      .then(() => {
        setIsUpdatingContract(false);
        setOpenContractDialog(false);
        getUsers();
      });
  };

  const contractTypeLabel = getContractTypeLabel(item.contractType);

  return (
    <TableRow
      aria-rowindex={index + 2}
      style={style}
      onClick={onClick}
      appearance={appearance}
    >
      {!assigned && (
        <TableSelectionCell
          checked={selected}
          checkboxIndicator={{
            "aria-label": "Select row",
          }}
        />
      )}
      <TableCell>
        <TableCellLayout
          media={
            <Avatar
              aria-label={`${item.lastName} ${item.firstName}`}
              name={`${item.lastName} ${item.firstName}`}
            />
          }
        >
          {`${item.lastName} ${item.firstName}`}
        </TableCellLayout>
      </TableCell>
      {assigned && (
        <TableCell>
          <TableCellLayout>{contractTypeLabel}</TableCellLayout>
        </TableCell>
      )}
      {assigned &&
        <TableCell>
          <TableCellLayout>
            <Button
              onClick={(e) => {
                e.stopPropagation();
                setContractType(parseContractType(item.contractType));
                setOpenContractDialog(true);
              }}
            >
              Zmień umowę
            </Button>
          </TableCellLayout>
        </TableCell>
      }
      {assigned &&
        <TableCell>
          <TableCellLayout>
            <Button onClick={(e) => {
              e.stopPropagation();
              setOpenDeleteDialog(true);
            }}>Usuń pracownika</Button>
          </TableCellLayout>
        </TableCell>
      }
      <AppConfirmdialog
        title='Potwierdź usunięcie pracownika'
        bodyTxt='Czy na pewno chcesz usunąć tego pracownika?'
        setOpen={setOpenDeleteDialog}
        open={openDeleteDialog}
        onAccept={deleteUser}
        isLoading={isDeleting}
      />
      <UserContractTypeDialog
        open={openContractDialog}
        setOpen={setOpenContractDialog}
        contractType={contractType}
        onContractTypeChange={setContractType}
        onSave={updateContractType}
        isLoading={isUpdatingContract}
      />
    </TableRow>
  );
};

export default UserListRow;
